/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const IconCompany = ({
    title,
    titleId = "tm-icon-IconCompany",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 9 13"
        aria-hidden={!title}
        height="1em"
        width="1em"
        role={title ? "img" : ""}
        aria-labelledby={titleId}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <g
            fill="none"
            fillRule="evenodd"
            transform="translate(-2)"
        >
            <path
                fill="#666"
                d="M2.2.733H11v11.734H7.333v-1.834H5.867v1.834H2.2V.733zm7.843 6.318v2.257H8.13V7.05h1.913zm-4.973 0v2.257H3.157V7.05H5.07zm2.487 0v2.257H5.643V7.05h1.914zM5.07 4.344V6.6H3.157V4.344H5.07zm2.487 0V6.6H5.643V4.344h1.914zm2.486 0V6.6H8.13V4.344h1.913zM5.07 1.636v2.256H3.157V1.636H5.07zm2.487 0v2.256H5.643V1.636h1.914zm2.486 0v2.256H8.13V1.636h1.913z"
            />
        </g>
    </svg>
);

export default IconCompany;
